import { Alert, Box, Button, Grid, Modal, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import useButtonStyles from "../../styles/useButtonStyles";
import { ReactElement, useState } from "react";
import { redirect, useNavigate } from "react-router-dom";
import { Stack } from "@mui/system";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export interface BasicModalPropTypes {
  title?: string;
  success?: boolean;
  setState?: Function;
  content?: ReactElement;
  open?: boolean;
  onClose?: () => void;
  children?: React.ReactNode;
  reference?: string;
  redirection?: string;
  buttonTex?: string;
}

const AlertMessage = (props: BasicModalPropTypes) => {
  const {
    title,
    success,
    setState,
    content,
    reference,
    redirection,
    buttonTex,
  } = props;
  const theme = useTheme();
  const buttonStyles = useButtonStyles();
  const navigate = useNavigate();

  const onCloseToRedirect = () => {
    setState && setState(false);
    redirection && navigate(redirection);
  };

  return (
    <Grid>
      <Modal
        open={true}
        onClose={() => {}}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "none",
          outline: "none",
          "&:focus": {
            outline: "none",
          },
        }}
      >
        <>
          {content ? (
            content
          ) : (
            <Grid
            sx={{background:theme.color?.background,width:"20%",height:"40%",px:6,borderRadius:"8px"}}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              {success ? (
                <>
                  <Grid display={"flex"} flexDirection={"column"} alignItems={"center"}>
                    <TaskAltIcon fontSize="large" style={{ color: "green" }} />
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      textAlign={"center"}
                      sx={{
                        marginTop: 3,
                        textAlign: "center",
                        color: theme?.color?.primary,
                        fontWeight: 600,
                        fontFamily: theme?.font?.fontFamily.primary,
                        fontSize: 15,
                      }}
                    >
                      Success!
                    </Typography>
                  </Grid>
                </>
              ) : (
                <Grid>
                  <ErrorOutlineIcon fontSize="large" style={{ color: "red" }} />
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    textAlign={"center"}
                    sx={{
                      marginTop: 3,
                      textAlign: "center",
                      color: theme?.color?.primary,
                      fontWeight: 600,
                      fontFamily: theme?.font?.fontFamily.primary,
                      fontSize: 15,
                    }}
                  >
                    Error!
                  </Typography>
                </Grid>
              )}

              {title && (
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  textAlign={"center"}
                  sx={{
                    textAlign: "left",
                    color: theme?.color?.primary,
                    fontWeight: 300,
                    fontFamily: theme?.font?.fontFamily.primary,
                    letterSpacing: 0.7,
                    fontSize: 12,
                    overflowWrap: "break-word",
                    maxWidth: "30ch",
                    my: 2,
                  }}
                >
                  {title}
                </Typography>
              )}

              {reference && (
                <Typography
                  id="member"
                  variant="h6"
                  textAlign={"center"}
                  sx={{
                    textAlign: "center",
                    color: theme?.color?.primary,
                    fontWeight: 300,
                    fontFamily: theme?.font?.fontFamily.primary,
                    letterSpacing: 0.7,
                    my: 2,
                  }}
                >
                  {reference}
                </Typography>
              )}

              <Button
                type="button"
                variant="contained"
                fullWidth
                sx={{
                  color: theme.color?.background,
                  backgroundColor: theme.color?.secondary,
                  marginTop: 2,
                  textTransform:"capitalize"
                }}
                onClick={onCloseToRedirect}
              >
                {buttonTex}
              </Button>
            </Grid>
          )}
        </>
      </Modal>
    </Grid>
  );
};

export default AlertMessage;
